import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-lister',
  templateUrl: './form-lister.component.html',
  styleUrls: ['./form-lister.component.scss']
})
export class FormListerComponent implements OnInit {

  constructor() { }

  @Input() title: string;
  @Input() items: string[];

  ngOnInit(): void {
  }

}
